import genFontSizes from './genFontSizes';
const genFontMapToken = fontSize => {
  // TODO: refactor to Duxton algorithm
  const fontSizePairs = genFontSizes(fontSize);
  const fontSizes = fontSizePairs.map(pair => pair.size);
  const lineHeights = fontSizePairs.map(pair => pair.lineHeight);
  const fontSizeMD = fontSizes[1];
  const fontSizeSM = fontSizes[0];
  const fontSizeLG = 16; // Dui
  const fontSizeXL = 18; // Dui
  const lineHeight = lineHeights[1];
  const lineHeightSM = lineHeights[0];
  const lineHeightLG = lineHeights[2];
  const lineHeightXL = lineHeights[3]; // Dui
  return {
    fontSizeSM,
    fontSize: fontSizeMD,
    fontSizeLG,
    fontSizeXL,
    // Dui start
    fontSizeHeading1: 40,
    fontSizeHeading2: 32,
    fontSizeHeading3: 24,
    fontSizeHeading4: 20,
    fontSizeHeading5: 18,
    // Dui end
    // Dui start
    fontSizeDisplay1: 72,
    fontSizeDisplay2: 56,
    fontSizeBody1: 18,
    fontSizeBody2: 16,
    fontSizeBody3: 14,
    fontSizeMetadata1: 12,
    fontSizeMetadata2: 10,
    // Dui end
    lineHeight,
    lineHeightXL,
    // Dui
    lineHeightLG,
    lineHeightSM,
    fontHeight: Math.round(lineHeight * fontSizeMD),
    fontHeightXL: Math.round(lineHeightXL * fontSizeXL),
    fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
    fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
    lineHeightHeading1: lineHeights[6],
    lineHeightHeading2: lineHeights[5],
    lineHeightHeading3: lineHeights[4],
    lineHeightHeading4: lineHeights[3],
    lineHeightHeading5: lineHeights[2],
    // Dui start
    lineHeightTagSM: 1.42857143,
    lineHeightTagXS: lineHeights[4],
    lineHeightDisplay1: lineHeights[9],
    lineHeightDisplay2: lineHeights[8],
    lineHeightBody1: lineHeights[2],
    lineHeightBody2: lineHeights[2],
    lineHeightBody3: lineHeights[3],
    lineHeightMetadata1: lineHeights[4],
    lineHeightMetadata2: lineHeights[6]
    // Dui end
  };
};
export default genFontMapToken;